import { put, call, take, fork } from 'redux-saga/effects'
import generalSaga from '../general'
import { SCORM_DELETE } from '../../reducers/scorm/type'
import { scormDeleteService } from '../../api/scorm'
import { scormDeleteSuccess, scormDeleteError } from '../../reducers/scorm/action'
import { operationFail } from '../../reducers/operation/action'

function* scormDeleteFlow(payload) {
  try {
    const { id, callback } = payload
    yield call(scormDeleteService, id)
    yield put(scormDeleteSuccess(id))
    if (callback) callback()
  } catch (error) {
    yield put(scormDeleteError())
    yield put(operationFail(error))
  }
}

export default function* scormDeleteWatcher() {
  while (true) {
    const action = yield take(SCORM_DELETE)
    const { payload } = action
    yield fork(generalSaga, scormDeleteFlow, payload)
  }
}
